module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "modalCardNews",
      "tabindex": "-1",
      "role": "dialog",
      "aria-labelledby": "exampleModalLabel",
      "aria-hidden": "true"
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "carousel slide",
    attrs: {
      "id": "carouselExampleIndicators",
      "data-ride": "carousel"
    }
  }, [(_vm.news != undefined) ? _c('div', {
    staticClass: "carousel-inner"
  }, _vm._l((_vm.news), function(actu) {
    return _c('div', {
      class: _vm.currentActu == _vm.news.indexOf(actu) ? 'carousel-item  active' : 'carousel-item '
    }, [_c('span', {
      staticClass: "title"
    }, [_vm._v(_vm._s(actu.Titre))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(actu.Details))])])
  })) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _vm._m(1)])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header"
  }, [_vm._v("\n\t\t\t\tActualités\n\t\t\t\t"), _c('button', {
    staticClass: "close",
    staticStyle: {
      "z-index": "99999"
    },
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "centerContent"
  }, [_c('a', {
    staticClass: "carousel-control-prev",
    attrs: {
      "href": "#carouselExampleIndicators",
      "role": "button",
      "data-slide": "prev"
    }
  }, [_c('span', {
    staticClass: "material-icons"
  }, [_vm._v("")])]), _vm._v(" "), _c('a', {
    staticClass: "carousel-control-next",
    attrs: {
      "href": "#carouselExampleIndicators",
      "role": "button",
      "data-slide": "next"
    }
  }, [_c('span', {
    staticClass: "material-icons"
  }, [_vm._v("")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7007ce62"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home/modals/modalCardNews/modalCardNews.vue.html
// module id = oxiV
// module chunks = 2